import React from "react";
import { Contact } from "components/common/Contact";

function OrgContact(props) {
  return <Contact />;
}

export { OrgContact };
